'use client'

import { Image as ImageIcon } from 'lucide-react'
import { getServerSideURL } from '@/utilities/getURL'

type UploadedLike = {
  url?: string | null
  filename?: string | null
  alt?: string | null
  focalX?: number | null
  focalY?: number | null
}

type ImageBlockProps = {
  blockType: 'courseImage'
  id?: string | null
  image?: UploadedLike | string | null
}

export const ImageBlockComponent: React.FC<ImageBlockProps> = ({ image }) => {
  const media = typeof image === 'object' ? image : null
  const serverURL = getServerSideURL()
  const imageURL = media?.url
    ? `${serverURL}${media.url}`
    : media?.filename
      ? `${serverURL}/media/${media.filename}`
      : null
  const focalX = typeof media?.focalX === 'number' ? media.focalX : 50
  const focalY = typeof media?.focalY === 'number' ? media.focalY : 50

  return (
    <figure className="group overflow-hidden rounded-2xl shadow-lg ring-1 ring-border/30 transition-shadow hover:shadow-xl">
      {imageURL ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          alt={media?.alt || 'Afbeelding'}
          className="block h-auto w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
          src={imageURL}
          style={{ objectPosition: `${focalX}% ${focalY}%` }}
        />
      ) : (
        <div className="flex flex-col items-center justify-center bg-muted/20 p-12">
          <ImageIcon className="h-12 w-12 text-muted-foreground" />
        </div>
      )}
    </figure>
  )
}
